import { render, staticRenderFns } from "./wordsAnn.vue?vue&type=template&id=f37cadc2&scoped=true&"
import script from "./wordsAnn.vue?vue&type=script&lang=js&"
export * from "./wordsAnn.vue?vue&type=script&lang=js&"
import style0 from "./wordsAnn.vue?vue&type=style&index=0&id=f37cadc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37cadc2",
  null
  
)

export default component.exports